import { Button } from "@/components/ui/button";
import { Download } from "@/lib/public-icons";

/** Prints the page, or saves it as a PDF from the browser's print dialog. */
export function LegalPrintButton({ testId }: { testId: string }) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="font-ui"
      onClick={() => window.print()}
      data-print="hide"
      data-testid={testId}
    >
      <Download className="mr-2 size-4" aria-hidden="true" />
      Print or save as PDF
    </Button>
  );
}
